import normalizer from '@cordel/helpers/form/schema';

import {
  INVITATIONS,
} from './sections';

import {
  STORE_ID,
  EMAIL,
  PERMISSION,
} from './fields';

export default function schema() {
  return normalizer({
    sections: {
      [INVITATIONS]: {},
    },

    fields: {
      [EMAIL]: {
        section: INVITATIONS,
        type: 'input',
        label: 'Email',
        labelless: false,
        placeholder: 'nome@email.com',
        validations: [{
          type: 'blank',
        }, {
          type: 'email',
        }],
        size: 4,
      },
      [PERMISSION]: {
        section: INVITATIONS,
        type: 'select',
        label: 'Permissão',
        labelless: false,
        placeholder: 'Selecione a permissão',
        size: 4,
        validations: [{
          type: 'blank',
        }],
      },
      [STORE_ID]: {
        section: INVITATIONS,
        type: 'select',
        label: 'Loja',
        labelless: false,
        placeholder: 'Filtrar por loja',
        size: 4,
      },
    },
  });
}
